import { PRINTFUL_DTFLEX_MAX_HEIGHT_INCHES, PRINTFUL_DTFLEX_MAX_WIDTH_INCHES } from "../../merch/mockup/merchMockupConstants";

function MerchPreviewRulers({ printArea, printWidthInches, showRulers, showMeasurements, view, horizontalOffset, verticalOffset }) {
  if (!showRulers && !showMeasurements) return null;
  const horizontalLabels = createLabels(PRINTFUL_DTFLEX_MAX_WIDTH_INCHES, 2);
  const verticalLabels = createLabels(PRINTFUL_DTFLEX_MAX_HEIGHT_INCHES, 2);
  const remaining = PRINTFUL_DTFLEX_MAX_WIDTH_INCHES - printWidthInches;

  return (
    <div aria-hidden="true" style={{ ...overlayStyle, left: `${printArea.left}%`, top: `${printArea.top}%`, width: `${printArea.width}%`, height: `${printArea.height}%` }}>
      {showRulers && <><div style={horizontalRulerStyle}>{horizontalLabels.map((label) => <span key={label} style={tickStyle}>{label}{label ? '"' : ""}</span>)}</div><div style={verticalRulerStyle}>{verticalLabels.map((label) => <span key={label} style={verticalTickStyle}>{label}{label ? '"' : ""}</span>)}</div></>}
      {showMeasurements && (
        <div style={measurementStyle}>
          <strong>Maximum area: 12&quot; × 16&quot;</strong>
          <span>Current artwork width: {printWidthInches}&quot;</span>
          <span>Remaining horizontal space: {formatNumber(remaining)}&quot; total</span>
          <span>Centered side clearance: {formatNumber(remaining / 2)}&quot; per side</span>
          <span>Horizontal offset: {formatOffset(horizontalOffset)}</span>
          <span>Vertical offset: {formatOffset(verticalOffset)}</span>
        </div>
      )}
    </div>
  );
}

function createLabels(maximum, step) { const result = []; for (let value = 0; value <= maximum; value += step) result.push(value); return result; }
function formatNumber(value) { return Number(value.toFixed(2)); }
function formatOffset(value) { return `${value > 0 ? "+" : ""}${Number(value.toFixed(1))}%`; }
const overlayStyle = { position: "absolute", zIndex: 5, pointerEvents: "none" };
const horizontalRulerStyle = { position: "absolute", left: 0, right: 0, top: "-24px", display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(255,255,255,.4)", color: "#ddd", fontSize: "8px" };
const verticalRulerStyle = { position: "absolute", top: 0, bottom: 0, left: "-24px", display: "flex", flexDirection: "column", justifyContent: "space-between", borderRight: "1px solid rgba(255,255,255,.4)", color: "#aaa", fontSize: "8px" };
const tickStyle = { transform: "translateX(-50%)" };
const verticalTickStyle = { transform: "translateY(-50%)" };
const measurementStyle = { position: "absolute", left: "50%", bottom: "8px", transform: "translateX(-50%)", display: "flex", flexDirection: "column", gap: "3px", minWidth: "190px", padding: "8px 10px", borderRadius: "8px", background: "rgba(10,10,10,.88)", color: "#eee", fontSize: "9px", lineHeight: 1.35, textAlign: "center" };

export default MerchPreviewRulers;
